export default {
  name: "Facturen",

  types: {
    debit: "Debit",
    credit: "Credit",
  },

  history: {
    title: "Factuur geschiedenis",
    createdOn: "Aangemaakt op"
  },

  export: {
    title: "Exporteer verstuurde facturen",
    input: {
      startDate: "Start datum",
      endDate: "Eind datum",
    },
    button: {
      download: "Downloaden",
    },
  },

  api: {
    invoiceInvoice: {
      id: {
        notNull: "Er is iets fout gegaan, we weten niet welke factuur het is"
      },
      dueDate: {
        notNull: "Geeft een verloop datum op",
      },
      invoiceDate: {
        notNull: "Geef een factuur datum op",
      },
    },

    invoiceTarget: {
      id: {
        notNull: "Er is iets fout gegaan, we weten niet welke factuur het is"
      },
      entityTypeId: {
        notNull: "Geef aan of je een bedrijf of persoon wilt factureren",
      },
      targetId: {
        notNull: "Selecteer aan wie de factuur gericht is",
      },
      status: {
        invalid: "De ontvanger kan alleen gewijzigd worden in concept facturen",
      },
    },

    invoiceItems: {
      notNull: "Voeg een factuurregel toe aan de factuur",
      name: {
        notNull: "Alle factuur regels dienen van een naam voorzien te worden",
      },
    },

    // Todo - check and fix this error message
    pdf: {
      found: "PDF document kon niet gegenereerd worden omdat deze al bestaat. Pas het factuurnummer handmatig aan, of neem contact op met support.",
    },
  },
}
